define([
	"csi/def/ActionFactory",
	"./_StateAction"
], function(ActionFactory,_StateAction) {

	return ActionFactory.declare("RevertToApproved", _StateAction, {
		m_tag: "RevertToApproved"
	});
});